import React from "react";
import loaderImg from "../../assets/common-main-loader.gif";

export const Spinner = ({ parentClassName, className }: any) => {
  return (
    <div className={`inline-flex items-center justify-center ${parentClassName || ""}`}>
      <img
        src={loaderImg}
        alt="Loading"
        className={className || "h-6 w-auto"}
        draggable={false}
      />
    </div>
  );
};
